var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "favorite",
      class: { "favorite--active": _vm.active },
      on: { click: _vm.addInWishlist },
    },
    [_c("IconComponent", { attrs: { name: "heart-fill" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }